import web from "../src/images/portfolio0.jpg";
import app from "./images/portfolio1.jpg";
import andriod from "../src/images/portfolio02.png";
import digital from "../src/images/portfolio3.jpg";
import marketing from "../src/images/portfolio03.png";
import software from "../src/images/portfolio04.png";

const Sdata = [
    {
        imgsrc: web,
        title: "Web Development",
    },
    {
        imgsrc: andriod,
        title: "Andriod Development",
    },
    {
        imgsrc: digital,
        title: "Digital Development",
    },
    {
        imgsrc: marketing,
        title: "Marketing Development",
    },
    {
        imgsrc: software,
        title: "Software Development",
    },
    {
        imgsrc: app,
        title: "App Development",
    },
]

export default Sdata;